// src/parent/parentContentComponent/studentProfile/StudentProfile.jsx
import React, { useState, useEffect } from "react";
import Avatar from "react-avatar";
import "./StudentProfile.scss";
import axios from "axios";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import AllTestsPerformanceReportTabel from "../allTestsPerformanceReportTabel/AllTestsPerformanceReportTabel";
import images from "../../../utilities/images/images";
import TestPerformance from "../../shared/performance/TestPerformance";
import AnalysisPage from "../../shared/analysis/analysisPage/AnalysisPage";

// ⭐ IMPORT REDUX ACTIONS
import {
  setPaperId,
  setPlannerTestId,
  setPapers,
  setSinglePaper,
} from "../../redux/testDataSlice/TestDataSlice";

const StudentProfile = (props) => {
  let {
    token,
    tokenType,
    studentRollNum,
    setUserId,
    setStudentProfileDetails,
    startLoading,
    finishLoading,
    LoaderPopUp,
    loader,
    setParentTarget,

    // REDUX ACTIONS (connected below)
    setPaperId,
    setPlannerTestId,
    setPapers,
    setSinglePaper,
  } = props;

  const history = useHistory();

  const [state, setState] = useState({
    studentProfile: {},
    userId: "",
  });

  const [summaryTests, setSummaryTests] = useState([]); // all tests

  const { studentProfile, userId } = state;
  

  useEffect(() => {
    getStudentProfile();
  }, []);

  useEffect(() => {
    if (studentRollNum) fetchSummaryData();
  }, [studentRollNum]);

  // ⭐ FETCH STUDENT PROFILE DETAILS
  const getStudentProfile = async () => {
    const data = { roll_no: studentRollNum };

    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/Parentdashboard",
        data
      );

      if (response.data.status === 200) {
        setUserId(response?.data?.data?.user_id);
        setParentTarget(response?.data?.data?.target);

        setState((prev) => ({
          ...prev,
          studentProfile: response.data,
          userId: response.data.data.user_id,
        }));

        setStudentProfileDetails(response.data.data);
      }
    } catch (error) {
      console.log("PROFILE ERROR:", error);
    }
  };

  // ⭐ FETCH ALL TEST SUMMARY
  const fetchSummaryData = async () => {
    try {
      const data = {
        roll_no: studentRollNum,
        device: "Web",
      };

      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/SPR_StudentOverallSummary",
        data
      );

      if (response.data.status === 200) {
        setSummaryTests(response.data.student_data.data);
      }
    } catch (error) {
      console.log("Error fetching tests:", error);
    }
  };

  // ⭐ VIEW REPORT (same logic as Parent component)
  const handleViewReportBtn = (test) => {
    if (!test) return;

    setPaperId(test.paper_id);
    setPlannerTestId(test.planner_test_id);
    setPapers(test.papers);
    setSinglePaper(test);

    history.push({
      pathname: "/student-tests",
      state: { step: 2 },
    });
  };

  // --------------------------
  // ⭐ DYNAMIC STATS
  // --------------------------
  console.log("dd:",studentProfile)
  const testsAttempted = studentProfile?.appeared_count || 0;
  const totalTests = studentProfile?.total_test || 0;

  const classesAttended = studentProfile?.data?.attendance || 0;
  const totalClasses = studentProfile?.classes || 0;

  return (
    <>
      <div className="studentProfile">
        <section className="container">
          <div className="Card">
            <div className="card-body d-flex">
              {/* LEFT SECTION */}
              <div className="left d-flex">
                <div className="profile_img">
                  {studentProfile?.data?.image ? (
                    <img src={studentProfile?.data?.image} alt="profile-img" />
                  ) : (
                    <Avatar
                      name={studentProfile?.data?.name}
                      round={true}
                      size="205"
                      bgColor="#b50303"
                    />
                  )}
                </div>

                <div className="profile-content">
                  <h2>{studentProfile?.data?.name}</h2>
                  <ul>
                    <li>
                      <span className="lft-li">Class</span>
                      <span className="rght-li">
                        {studentProfile?.data?.classes}
                      </span>
                    </li>
                    <li>
                      <span className="lft-li">Campus:</span>
                      <span className="rght-li">
                        {studentProfile?.data?.center}
                      </span>
                    </li>
                    <li>
                      <span className="lft-li">Roll.no:</span>
                      <span className="rght-li">
                        {studentProfile?.data?.roll_no}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* RIGHT SECTION (DYNAMIC NOW) */}
             <div className="right_data">

  {/* TEST ATTEMPTED */}
  <div className="td">
    <div className="icon_wrap">
      <img src={images.test_attempt} alt="test" />
    </div>
    <div className="tc">
      <span className="tc_title">Test Attempted</span>
      <span className="tc_count">
        {testsAttempted}/{totalTests}
      </span>
    </div>
  </div>

  {/* CLASSES ATTENDED */}
  <div className="td pink">
    <div className="icon_wrap">
      <img src={images.users_icon} alt="class" />
    </div>
    <div className="tc">
      <span className="tc_title">Classes Attended</span>
      <span className="tc_count">
        {classesAttended}/{totalClasses}
      </span>
    </div>
  </div>

</div>

            </div>
          </div>
        </section>
      </div>

      {/* ⭐ LATEST TEST */}
      {summaryTests.length > 0 && (
        <TestPerformance latestTest={summaryTests[0]} />
      )}

      {/* ⭐ FULL ANALYSIS PAGE */}
     <AnalysisPage
  allTests={summaryTests}
  studentRollNum={studentRollNum}    
  handleStep2={handleViewReportBtn}
  setPaperId={setPaperId}
  setPlannerTestId={setPlannerTestId}
  setPapers={setPapers}
  setSinglePaper={setSinglePaper}
/>

    </>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  token: state.auth.authToken,
});

// connect redux actions
export default connect(
  (state) => ({
    loader: state.ui.loader,
    token: state.auth.authToken,
  }),
  {
    setPaperId,
    setPlannerTestId,
    setPapers,
    setSinglePaper,
  }
)(StudentProfile);
